module.exports = __webpack_public_path__ + "img/index_bookBtn02.4fd068d3.png";